import { StandardEvents } from '@shopify/events';

const FREE_SHIPPING_CENTS = 5500;
const money = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

function build() {
  if (document.getElementById('vm-add-dlg')) return;
  const d = document.createElement('dialog');
  d.id = 'vm-add-dlg';
  d.className = 'vm-dlg';
  d.innerHTML = `
    <div class="vm-dlg__box">
      <button type="button" class="vm-dlg__x" data-close aria-label="Chiudi">&times;</button>
      <div class="vm-add__ok"><svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="13"/><path d="M10 16.5l4 4 8-9"/></svg>Aggiunto al carrello!</div>
      <h3>Finalizza ora il tuo ordine</h3>
      <p class="vm-add__lim vm-limited vm-limited--block">Fine stagione: scorte limitate</p>
      <div class="vm-add__timer">
        <span data-vm-today>Ordina entro le <span data-vm-cutoff></span> e spediamo oggi<b class="vm-big" data-vm-countdown></b></span>
        <span data-vm-later hidden>Ordina ora: spediamo <b data-vm-shipday></b></span>
      </div>
      <p class="vm-add__deliv">Completalo ora e ricevilo <b data-vm-delivery></b></p>
      <p class="vm-add__ship" data-ship></p>
      <div class="vm-add__bar"><i data-bar></i></div>
      <div class="vm-add__btns">
        <a class="vm-btn vm-btn--accent vm-btn--block" href="/checkout">Finalizza ora</a>
        <button type="button" class="vm-btn vm-btn--ghost vm-btn--block" data-close>Continua gli acquisti</button>
        <a class="vm-add__cart" href="/cart"><u>Vedi il carrello</u></a>
      </div>
    </div>`;
  document.body.appendChild(d);
  d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
  d.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => d.close()));
}

async function updateShipping(d) {
  try {
    const cart = await (await fetch('/cart.js')).json();
    const left = FREE_SHIPPING_CENTS - cart.total_price;
    const pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIPPING_CENTS) * 100));
    d.querySelector('[data-bar]').style.width = pct + '%';
    d.querySelector('[data-ship]').innerHTML = left > 0
      ? 'Ti mancano <b>' + money.format(left / 100) + '</b> per la spedizione gratuita'
      : '<b>Hai la spedizione gratuita!</b>';
  } catch (e) { /* silenzioso */ }
}

function show() {
  build();
  const d = document.getElementById('vm-add-dlg');
  updateShipping(d);
  if (!d.open) d.showModal();
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;
  event.promise
    ?.then(({ detail }) => {
      if (detail?.didError) return;
      setTimeout(show, 200);
    })
    .catch(() => {});
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
else build();